// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { SpAlert } from '../../../components/sp-alert/sp-alert.model';

/** @ngInject */
export function Controller(
    $location,
    $rootScope,
    $scope,
    $state,
    $translate,
    SamlService
) {
    var appKey = $state.params.applicationId;

    $scope.infoSamlMsg = $translate.instant('saml.messages.logging_process');

    SamlService.getSPSamlData.get({
        SAMLTracker: $location.search().SAMLTracker,
        appKey : appKey,
    }, function(data) {
        if (data.authorized) {
            $scope.infoSamlMsg = $translate.instant('saml.messages.logging_process');
            $('#SAMLResponse').val(data.samlResponse);
            $('#RelayState').val(data.relayState);

            if (null == data.casLt) {
                $('#lt').remove();
            } else {
                $('#lt').val(data.casLt);
            }

            if (null == data.casExecution) {
                $('#execution').remove();
            } else {
                $('#execution').val(data.casExecution);
            }

            if (null == data.casEventId) {
                $('#_eventId').remove();
            } else {
                $('#_eventId').val(data.casEventId);
            }
            
            $('#samlloginForm').attr('action', data.redirectionLink);
            
            $('#samlloginForm').submit();
           
        } else {                
            $state.go('public.logout-saml');
        }
    }, function(error) {
        if (error.data.serviceErrorCode == 'ERR_101204') {
            $rootScope.topLevelMessage = new SpAlert('danger', error.data.message);
            
            $scope.infoSamlMsg = error.data.message;
        } else {
            $rootScope.topLevelMessage = new SpAlert('danger', 'saml.messages.not_authorized');
            $scope.infoSamlMsg = $translate.instant('saml.messages.not_authorized');
        }
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/saml-login/saml-login.controller.js